// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_Z3Q","cls2":"ReportList-cls2_o5_ ReportList-cls1_Z3Q"};